import * as React from "react";
import PropTypes from "prop-types";
import InputField from "./InputField";

export default class DateTimeField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["time", "date"]).isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxLength: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func,
    error: PropTypes.string,
  };

  state = {
    value: this._extractStateValue(this.props),
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({ value: this._extractStateValue(nextProps) });
    }
  }

  componentDidMount = () => {
    this._resetDefaultValue();

    // Because a default value may be set as part of object initialization,
    // we need to explicitly call onChange to update any listeners with the
    // new value.
    if (this.props.onChange && this.props.value !== this.state.value) {
      this.props.onChange(this.props.value);
    }
  };

  componentDidUpdate = () => {
    this._resetDefaultValue();
  };

  _extractStateValue(props) {
    let value = props.value || "";

    if (props.type === "time") {
      if (props.value == null) {
        // HH:MM
        const hoursAndMinutes = new Date().toTimeString().slice(0, 5);
        value = hoursAndMinutes;
      } else if (props.value === "no value") {
        // times explicitly set to "no value" should not default to now
        value = "";
      }
    }

    if (props.type === "date") {
      if (props.value == null) {
        // YYYY-MM-DD
        const dateString = new Date().toISOString().slice(0, 10);
        value = dateString;
      } else if (props.value === "no value") {
        // dates explicitly set to "no value" should not default to today
        value = "";
      }
    }

    if (this.props.onChange) {
      this.props.onChange(value);
    }

    return value;
  }

  _handleChange = (event) => {
    const { value } = event.currentTarget;
    this.setState({ value });

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  _resetDefaultValue = () => {
    // The "value" attribute of HTML5 date and time inputs technically controls the defaultValue
    // property of the element and only incidentally changes the UI. On iOS, the "clear"
    // button calls onChange with the defaultValue instead of an empty string like other
    // platforms. After the element is rendered, clear the defaultValue of date and time inputs
    // so that the "clear" button will work on iOS.
    if (this.input) {
      this.input.defaultValue = "";
    }
  };

  _captureRef = (el) => {
    this.input = el;
  };

  render() {
    const { label } = this.props;

    const { value } = this.state;
    // add a label on the left for date and time inputs
    const hasLeftLabel = Boolean(label);

    return (
      <InputField
        {...this.props}
        captureRef={this._captureRef}
        value={value}
        onChange={this._handleChange}
        hasLeftLabel={hasLeftLabel}
      />
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/DateTimeField.jsx